import script from "./BatchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__